var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.Config.STANDALONE ? _c("asta-drawer-standalone") : _c("asta-drawer"),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "panoramica-focus-topbar" } },
        [!_vm.panoramicaFocusActive ? _c("asta-nav") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm.showLayoutPanoramica
        ? _c("div", [_c("layout-panoramica")], 1)
        : _c("div", [
            _vm.is_mobile
              ? _c("div", [_c("layout-tavolo-mobile")], 1)
              : _c("div", [_c("layout-tavolo-desktop")], 1),
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "panoramica-focus-footer" } },
        [
          !_vm.panoramicaFocusActive
            ? _c("asta-footer", {
                attrs: { fixed: "", paddedTop: _vm.is_mobile },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.admin ? _c("brain") : _vm._e(),
      _vm._v(" "),
      _vm.admin
        ? _c("asta-chooser", { attrs: { selected: _vm.selectedChooser } })
        : _vm._e(),
      _vm._v(" "),
      _vm.mode_random ? _c("asta-auctioneer-random") : _c("asta-auctioneer"),
      _vm._v(" "),
      _vm.mode_selvaggia ? _c("asta-selvaggia") : _vm._e(),
      _vm._v(" "),
      _vm.mode_bustachiusa ? _c("asta-busta-chiusa") : _vm._e(),
      _vm._v(" "),
      _vm.mode_poker ? _c("asta-poker") : _vm._e(),
      _vm._v(" "),
      _c("asta-sblocco"),
      _vm._v(" "),
      _c("asta-come-funziona"),
      _vm._v(" "),
      _c("asta-impostazioni"),
      _vm._v(" "),
      _c("asta-numpad"),
      _vm._v(" "),
      _c("asta-logs"),
      _vm._v(" "),
      _c("asta-order"),
      _vm._v(" "),
      _c("dialog-scartati"),
      _vm._v(" "),
      _c("dialog-scarta-calciatori"),
      _vm._v(" "),
      _c("dialog-rose-lega"),
      _vm._v(" "),
      _vm.Config.AVATAR_OR_FLAG === "avatar"
        ? _c("dialog-galleria-calciatori")
        : _vm._e(),
      _vm._v(" "),
      _vm.is_mobile ? _c("dialog-asta-rosa") : _vm._e(),
      _vm._v(" "),
      _vm.is_mobile ? _c("dialog-plan") : _vm._e(),
      _vm._v(" "),
      !_vm.Config.STANDALONE ? _c("dialog-stati-mercati") : _vm._e(),
      _vm._v(" "),
      _vm.Config.STANDALONE ? _c("dialog-elimina-squadra") : _vm._e(),
      _vm._v(" "),
      _c("dialog-change-log"),
      _vm._v(" "),
      _c("dialog-promo-panoramica"),
      _vm._v(" "),
      _c("dialog-panoramica-mobile-info"),
      _vm._v(" "),
      _c("valore-edit"),
      _vm._v(" "),
      _c("asta-change-admin"),
      _vm._v(" "),
      _vm.Config.STANDALONE ? _c("asta-edit-squadra") : _vm._e(),
      _vm._v(" "),
      _vm.Config.STANDALONE ? _c("asta-ruoli-custom") : _vm._e(),
      _vm._v(" "),
      !_vm.Config.STANDALONE ? _c("allinea-rose") : _vm._e(),
      _vm._v(" "),
      !_vm.Config.STANDALONE ? _c("swal-import-rose") : _vm._e(),
      _vm._v(" "),
      !_vm.Config.STANDALONE ? _c("swal-save-rose") : _vm._e(),
      _vm._v(" "),
      _c("swal-download-rose"),
      _vm._v(" "),
      _c("swal-asta-in-corso"),
      _vm._v(" "),
      _c("swal-admin"),
      _vm._v(" "),
      _c("swal-admin-escluso"),
      _vm._v(" "),
      _c("swal-remove-calciatore-assegnato"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }